import ApiBudgety from '@/api/apiBudgety'

export const menuService = {
  getByIdPerfil,
  findAll,
  guardarAccceso,
  guardarAcccesoRange,
}

async function getByIdPerfil(id) {
  return await ApiBudgety.get('Menu/FindByIdPerfil/' + id)
}

async function findAll() {
  return await ApiBudgety.get('Menu/FindAll/')
}

async function guardarAccceso(body) {
  return await ApiBudgety.post('Menu/UpdateAccesoPerfil/', body)
}

async function guardarAcccesoRange(body) {
  return await ApiBudgety.post('Menu/InsertOrUpdateAccesoPerfilRange/', body)
}
